import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { Actions as ACTIONS } from '../../store/actions/workLocationActions';

import ReactDOM from "react-dom";
// import axios from 'axios';
import Select from 'react-select';
import _ from 'lodash';
import { format, setHours, setMinutes, setSeconds, setDate, differenceInDays, differenceInMinutes } from 'date-fns'
import { XMarkIcon, ArrowDownTrayIcon } from '@heroicons/react/20/solid'
import Spinner from "../common/Spinner";

const AttachmentModal = ({
  mode,
  workLocation,
  workLocationType,
  showAttachments,
  getAttachment,
  downloading,
  modalSaving,
  saveworkLocation,
}) => {

  if (!workLocation) {
    return null;
  }

  return (
    <div className="modal" tabindex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="block block-themed block-transparent remove-margin-b">
            <div className="block-header bg-primary-dark">
              <ul className="block-options">
                <li>
                  <button type="button" onClick={() => { showAttachments(null) }}>
                    <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                  </button>
                </li>
              </ul>
              <h3 className="block-title">Attachments for {workLocationType} workLocation {format(new Date(workLocation.date), "do MMM yyyy")}</h3>
            </div>
            <div className="block-content">

              {
                workLocation.attachments.map(attachment => (
                  <div>
                    <span style={{
                      fontWeight: "bold"
                    }}>{attachment.byName}</span>
                    <span style={{
                      fontSize: "12px"
                    }}> - {format(new Date(attachment.createdAt), "do MMM yyyy HH:mm")}</span>
                    <p>
                      {attachment.name}
                      {
                        downloading && downloading.includes(attachment.key) &&
                        <a
                          style={{ marginLeft: '5px' }}
                          className="btn btn-xs btn-default"
                        >
                          <Spinner
                            style={{ height: "1.5em", verticalAlign: 'middle' }}
                            className="animate-spin -ml-1 mr-3 h-5 w-5 "
                          />
                        </a>
                      }

                      {
                        !(downloading && downloading.includes(attachment.key)) &&
                        <a
                          onClick={() => {
                            getAttachment({
                              key: attachment.key,
                              agreement: workLocation.agreement
                            })
                          }}
                          style={{ marginLeft: '5px' }}
                          className="btn btn-xs btn-default"
                        >
                          <ArrowDownTrayIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                        </a>
                      }
                    </p>

                  </div>
                ))
              }


            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {

  const {
    workLocationTypes,
  } = state.workLocation


  const workLocation = state.workLocation.showAttachments;

  return {
    workLocation,
    modalSaving: state.workLocation.modalSaving,
    downloading: state.workLocation.downloading,
    workLocationType: workLocationTypes && workLocation && _.find(workLocationTypes, { id: workLocation.type }).name,

  }
}

const mapDispatchToProps = dispatch => ({
  showAttachments: (workLocation) => dispatch(ACTIONS.showAttachments(workLocation)),
  getAttachment: (attachment) => dispatch(ACTIONS.getAttachment(attachment)),
  saveworkLocation: (workLocation) => dispatch(ACTIONS.saveWorkLocation(workLocation)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AttachmentModal) 
